export default __webpack_public_path__ + "static/media/whiteFB.2fed661a.svg";